module.exports = __webpack_public_path__ + "img/Group 1934 (1).29f1d21c.svg";